<div class="recurrence" [formGroup]="scheduleReport.scheduleForm">
   <div class="two-row">
      <div class="dates">
         <div>
            <div class="overline">Start Date *</div>
            <div class="group">
               <ng-container
                  *ngTemplateOutlet="date; context: { control: scheduleReport.scheduleForm.get('startDate'), required: true, direction: 'from' }"></ng-container>
            </div>
         </div>
         <div *ngIf="!scheduleReport.no_end_date">
            <div class="overline">End Date *</div>
            <div class="group">
               <ng-container
                  *ngTemplateOutlet="date; context: { control: scheduleReport.scheduleForm.get('endDate'), required: true, direction: 'to', min:scheduleReport.scheduleForm.get('startDate')?.value || today }"></ng-container>
            </div>
         </div>
      </div>
      <div class="checkbox">
         <mat-checkbox formControlName="no_end_date" [disabled]="false" [color]='primaryColor'
            (change)="setNoEnd($event.checked)">No
            End Date</mat-checkbox>
      </div>

   </div>
   <div class="row">
      <div class="time">
         <div class="overline">Start Time *</div>
         <div class="group">
            <mat-form-field *ngIf="'startTime' as field">
               <mat-label>From</mat-label>
               <input #input matInput placeholder="00:00" [required]="true" autocomplete="off" [formControlName]="field"
                  (blur)="formatTime(input.value,field)" (click)="breakpoints.large ? '' : openClock(field)" />
               <mat-icon matSuffix class="clock" (click)="openClock(field)" zindex="-1">schedule</mat-icon>
               <mat-error libInputErrors [control]="scheduleReport.scheduleForm.get(field)"></mat-error>
            </mat-form-field>
         </div>
      </div>
   </div>
   <div class="two-row" *ngIf="(scheduleReport.types) == 'weekly'">
      <div>
         <div class="overline">Frequency</div>
         <div class="groupDays">
            <div class="days">
               <mat-button-toggle-group formControlName="frequency_week" [value]="scheduleReport.frequency_week" multiple>
                  <mat-button-toggle *ngFor="let day of days$ | async" class="dayType" [value]="day"
                     [disabled]="false">{{day | uppercase}}
                  </mat-button-toggle>
               </mat-button-toggle-group>
            </div>

         </div>
      </div>
      <div class="clearAll">
         <button mat-stroked-button (click)="clearAll()">CLEAR ALL
        </button>
      </div>
   </div>

   <div class="three-row" *ngIf="(scheduleReport.types) == 'monthly'">
      <div>
         <div class="overline">Select Day(s)</div>
         <div class="groupDays">
            <div class="days">
               <div class="date-picker mat-elevation-z2" >
                  <button *ngFor="let date of monthlyDays$ | async" 
                          [color]='primaryColor'
                          mat-button 
                          [class.selected]="isDateSelected(date)"
                          (click)="toggleDate(date)">
                    {{ date }}
                  </button>
                </div>
            </div>
         </div>
         <br>
         <div>
            * Reports will not run on selected days if they are not available in the month
         </div>
      </div>
      <div class="clearAll">
         <button mat-stroked-button (click)="clearAll()">CLEAR ALL
        </button>
      </div>
   </div>

   <ng-template #date let-control="control" let-required="required" let-direction="direction" let-min="min">
      <ng-container>
         <mat-form-field>
            <mat-label>{{direction | titlecase}}</mat-label>
            <input matInput autocomplete="off" [required]="required" [placeholder]="datePlaceholder" [min]="min" [matDatepicker]="datepicker" [formControl]="control">
            <mat-datepicker-toggle matSuffix [for]="datepicker" tabIndex="-1"></mat-datepicker-toggle>
            <mat-datepicker #datepicker [touchUi]="!breakpoints.large"></mat-datepicker>
            <mat-error libInputErrors [control]="control"></mat-error>
         </mat-form-field>
      </ng-container>
   </ng-template>